





















































import { computed, defineComponent, PropType, useContext, useRoute } from '@nuxtjs/composition-api';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppRectButton from '~/components/partials/App/AppRectButton.vue';
import RelatedLesson from '~/components/partials/College/RelatedLesson.vue';
import { useEnotecaApp } from '~/composables/useEnotecaApp';
import { useStore } from '~/composables/useStore';
import { url } from '~/utils';
import { CollegeLessonQuiz } from '~/types/common';
import { CollegeLessonType } from '~/enums';

export default defineComponent({
  components: {
    AppIcon,
    AppRectButton,
    RelatedLesson,
  },
  props: {
    quiz: {
      type: Object as PropType<CollegeLessonQuiz>,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    selectedNumber: {
      type: String,
      required: true,
    },
    relatedLesson: {
      type: Object,
      default: undefined,
    },
    relatedLessonStatus: {
      type: String,
      default: '',
    },
    lessonType: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { i18n } = useContext();
    const route = useRoute();
    const store = useStore();
    const pageNumber = Number(route.value.params.page);
    const { isEnotecaAppWebView } = useEnotecaApp();
    const tag = computed(() => (isEnotecaAppWebView.value ? 'a' : undefined));

    const isCorrect = computed(() => props.selectedNumber === props.quiz.answer.toString());

    /**
     * 次のページへのリンクを設定する
     * ・最終ページの場合 → 講座詳細へのリンク
     * ・最終ページでない場合 → 次のページへのリンク
     * ※前提として、各講座種別(lessonType)が渡されていること
     */
    const nextUrl = computed(() => {
      if (route.value.path === url('COLLEGE_QUIZ_DAILY_RESULT')) {
        return url('COLLEGE_QUIZ_DAILY');
      }
      if (pageNumber >= store.state.college.detail.lessonInfo.quizIds.length) {
        if (props.lessonType === CollegeLessonType.AREA) {
          return url('COLLEGE_PRODUCING_AREA_DETAIL', { id: route.value.params.id });
        }
        return url('COLLEGE_BASIC_DETAIL', { id: route.value.params.id });
      }
      if (props.lessonType === CollegeLessonType.AREA) {
        return url('COLLEGE_PRODUCING_AREA_QUIZ', { id: route.value.params.id, page: pageNumber + 1 });
      }
      return url('COLLEGE_BASIC_QUIZ', { id: route.value.params.id, page: pageNumber + 1 });
    });
    const nextButtonValue = computed(() => {
      if (route.value.path === url('COLLEGE_QUIZ_DAILY_RESULT')) {
        return i18n.t('College-01.answer.next.detail');
      }
      return pageNumber >= store.state.college.detail.lessonInfo.quizIds.length
        ? i18n.t('College-01.answer.next.detail')
        : i18n.t('College-01.answer.next.quiz');
    });

    return {
      url,
      tag,
      isCorrect,
      pageNumber,
      nextUrl,
      nextButtonValue,
    };
  },
});
